import React from 'react'
import { Provider as ApplicationUserProvider } from './application-user'
import { Provider as LoadingProvider } from './isLoading'
import { CartProvider } from './CartContext'

const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <LoadingProvider>
      <ApplicationUserProvider>
        <CartProvider>
          {children}
        </CartProvider>
      </ApplicationUserProvider>
    </LoadingProvider>
  )
}

export default AppProvider
